import { useState, useEffect } from "react"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ResponsiveAppBar from "../ResponsiveAppBar"
import ResponsiveFooter from "../ResponsiveFooter";

import { Link } from 'react-router-dom';
import { Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';


import * as React from 'react';

import * as constants from "../constants.js"


const ChangeUserPreferences = () => {
  const [user, setUser] = useState('');
  const [email, setEmail] = useState('');
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteAccount = async () => {
    const resp = await axios.create({
      withCredentials: true,
    }).post("//" + constants.BASE_URL + "/delete_user", {});
    navigate('/login');
  };


  const linkStyle = {
    textDecoration: 'underline', // Add an underline to make it look like a link
    color: 'blue', // Change the color to make it stand out
  };

  const linkStyleDanger = {
    textDecoration: 'underline', // Add an underline to make it look like a link
    color: 'red', // Change the color to make it stand out
  };

  useEffect(() => {
    (async () => {
      try {
        const resp = await axios.create({
          withCredentials: true,
        }).get("//" + constants.BASE_URL + "/@me");
        setUser(resp.data);
        setEmail(resp.data.email);
      } catch (error) {
        navigate('/login');
      }
    })();
  }, []);

  const cardStyle = {
    borderRadius: '10px', // Adjust the value to control the roundness of the corners
    // You can also add other styles like backgroundColor, boxShadow, etc.
  };

  return (
    <div className="home">
      <ResponsiveAppBar />
      <div className="body-content">
        <br></br>
        <h2>Nutzereinstellungen</h2>
        <br></br>

        <Card style={cardStyle}>
          <CardContent>
            <Link to="/change-email" style={linkStyle}>{email}</Link>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            Hier kannst du deine E-Mail ändern
          </CardContent>
        </Card>
        <br></br>
        <Card style={cardStyle}>
          <CardContent>
            <Link to="/change-password" style={linkStyle}>Passwort ändern</Link>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            Hier kannst du dein Passwort ändern
          </CardContent>
        </Card>

        <br></br>
        <Card style={cardStyle}>
          <CardContent>
            <Link onClick={handleDeleteClick} style={linkStyleDanger}>Account löschen</Link>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            Hier kannst du deinen Account löschen
          </CardContent>
        </Card>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Account wirklich Löschen</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Willst du deinen Account wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={deleteAccount} color="error">
              Ja, löschen
            </Button>
            <Button onClick={handleClose} color="primary" autoFocus>
              Abbrechen
            </Button>
          </DialogActions>
        </Dialog>

      </div>
      <ResponsiveFooter />
    </div>
  );
}

export default ChangeUserPreferences;